<template>
  <div id="app">
    <router-view />
    <!-- <el-backtop target="body" :bottom="100" :right="150" style="background: none;"> -->
    <div
      v-if="show"
      class="float_scroll"
      @click="toTop"
    >
      <div
        style="{
          height: 100%;
          width: 100%;
          box-shadow: 0 0 6px rgba(0,0,0, .12);
          text-align: center;
          background-image: url(/official/static/img/home/top_box.svg);
          background-size: 100% auto;
        }"
      >
        <img
          class="top_move"
          src="/official/static/img/home/top_move.svg"
          alt
        >
      </div>
    </div>
    <!-- </el-backtop> -->
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      show: false
    }
  },
  watch: {
    $route (to, from) {
      // console.log(to)
      if (to.name === 'home') {
        document.querySelector('#float_fb_plugin').style.display = 'block'
      }else {
        document.querySelector('#float_fb_plugin').style.display = 'none'
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', () => {
      let scrollt =
        document.documentElement.scrollTop + document.body.scrollTop
      if (scrollt > 200) {
        this.show = true
      }
      if (scrollt === 0) {
        this.show = false
      }
    })

    function detectIE () {
      var ua = window.navigator.userAgent

      var msie = ua.indexOf('MSIE ')
      if (msie > 0) {
        // IE 10 or older => return version number
        return true
      }

      var trident = ua.indexOf('Trident/')
      if (trident > 0) {
        // IE 11 => return version number
        return true
      }

      var edge = ua.indexOf('Edge/')
      if (edge > 0) {
        // Edge (IE 12+) => return version number
        return true
      }

      // other browser
      return false
    }

    if (!!window.ActiveXObject || 'ActiveXObject' in window || detectIE()) {
      window.addEventListener(
        'hashchange',
        () => {
          let currentPath = window.location.hash.slice(1)
          if (this.$route.path !== currentPath) {
            this.$router.push(currentPath)
          }
        },
        false
      )
    }
  },
  methods: {
    toTop () {
      document
        .querySelector('body')
        .scrollIntoView({ block: 'start', behavior: 'smooth' })
      this.show = false
    }
  }
}
</script>

<style>
a {
  text-decoration: none;
  color: #fff;
}
.center {
  text-align: center;
}
body {
  color: #fff;
}
html,
body {
  padding: 0px;
  margin: 0px;
  width: 100%;
  height: 100%;
}
#app {
  padding-top: 60px;
  /* overflow: auto; */
}

.el-dropdown-menu.el-popper {
  margin-top: 0px;
}

.right-float {
  float: right;
}

div:focus {
  outline: none;
}
video:focus {
  outline: none;
}
img {
  border-style: none;
  border: 0;
}

.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  pointer-events: inherit !important;
}

.home-color {
  color: #1f9d56;
}
.home-p-color {
  color: #727272;
}
.bg-color {
  /* background: #e2e2e2; */
  background: #f0f0f0;
}
.bg-p-color {
  color: #828282;
}

/* element样式 */
.el-tabs__item:focus.is-active.is-focus:not(:active) {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.el-popover.el-popper:focus {
  outline: none;
}
.el-form-item.is-error .el-input__inner,
.el-form-item.is-error .el-input__inner:focus,
.el-form-item.is-error .el-textarea__inner,
.el-form-item.is-error .el-textarea__inner:focus,
.el-message-box__input input.invalid,
.el-message-box__input input.invalid:focus {
  border-color: #cc7272 !important;
}
</style>

<style scoped lang="scss">
@keyframes d {
  0% {
    -webkit-transform: translateX(0px) translateY(30px);
    transform: translateX(0px) translateY(30px);
  }
  100% {
    -webkit-transform: translateX(0px) translateY(-30px);
    transform: translateX(0px) translateY(-30px);
  }
}
.float_scroll {
  position:fixed;
  width:40px;
  height:40px;
  border-radius: 50%;
  right:5px;
  bottom:60px;
  z-index:4;
  cursor:pointer;
  overflow: hidden;

  &:hover {
    .top_move {
      animation: d 1s infinite;
      animation-timing-function: linear;
    }
  }
}

.top_move {
  width: 100%;
  display: block;
  transform: translateX(0px) translateY(0px);
}
</style>
